<!-- компонент vdsView: просмотр VDS -->
<template>
	<div v-if="this.$store.state.is_auth">

		<template v-if="!form_ErrorMessage">

			<!-- блок с локальным сообщением об ошибке -->
			<transition name="fadeControl" key="transitionError">
				<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
					<button v-show="localErrorMessageButton" @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
					<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessageClear)"></span>
				</div>
			</transition>
			<!-- ===================================== -->

			<!-- ГЛАВНЫЙ БЛОК VDS -->
			<div v-if="isDataReady" class="w5-vds-view-wrapper">
				<!-- блок с названием VDS -->
				<div class="font-size-120 name-in-vds">
					<span :class="'flag-icon flag-icon-' + dataCenter.country"></span>
					<span v-if="Access" class="font-weight-500 w5-modal-link" @click.stop.prevent="changeServiceName">{{ serviceName | ftc }}</span>
					<span v-else class="font-weight-500">{{ serviceName | ftc }}</span>
				</div>
				<br>
				<!-- блок с информацией о VDS -->
				<div class="margin-top-10 font-size-95">
					<!-- IP -->
					<span class="margin-right-10" :class="{ 'text-strike': !serviceIPActive }">{{ serviceIP }}</span>
					<!-- Status -->
					<span v-if="serviceStatus['loader']" class="margin-right-10" :class="'w5-status-color-' + serviceStatusClear">{{ serviceStatus['status'] | capitalize }} <img src="../../assets/img/loading-hor16.gif" style="margin-left: 6px" /></span>
					<span v-else-if="serviceStatus['timer']" class="margin-right-10" :class="'w5-status-color-' + serviceStatusClear">{{ serviceStatus['status'] | capitalize }} <font-awesome-icon icon="clock" style="margin-left: 6px" /></span>
					<span v-else class="margin-right-10" :class="'w5-status-color-' + serviceStatusClear">{{ serviceStatus['status'] | capitalize }}</span>
					<!-- template -->
					<span class="margin-right-10">
						<img :src="APIServerUrl + serviceTemplate['template_image']['value']" width="18" height="18" />
						<span>{{ serviceTemplate['template_name']['value'] }}</span>
					</span>
					<br class="visible-xs" />
					<!-- plan -->
					<span>
						{{ servicePlanInfo['cpu']['title'] | ftc }}: <strong>{{ servicePlanInfo['cpu']['total'] ? servicePlanInfo['cpu']['total'] : servicePlanInfo['cpu']['value'] }} {{ servicePlanInfo['cpu']['for'] | ftc }}</strong>
						 &nbsp; 
						{{ servicePlanInfo['ram']['title'] | ftc }}: <strong>{{ servicePlanInfo['ram']['total'] ? servicePlanInfo['ram']['total'] : servicePlanInfo['ram']['value'] }} {{ servicePlanInfo['ram']['for'] | ftc }}</strong>
						 &nbsp; 
						<br class="visible-xs" />
						{{ servicePlanInfo['disk']['title'] | ftc }}: <strong>{{ servicePlanInfo['disk']['total'] ? servicePlanInfo['disk']['total'] : servicePlanInfo['disk']['value'] }} {{ servicePlanInfo['disk']['for'] | ftc }}</strong>
						 &nbsp; 
						{{ servicePlanInfo['traff']['title'] | ftc }}: <strong>{{ servicePlanInfo['traff']['value'] }} {{ servicePlanInfo['traff']['for'] | ftc }}</strong></span>
					<!-- account & sshkey & iso -->
					<div v-if="isAccountBlockVisible" class="margin-top-10">
						<span v-if="$store.state.user_type === 'admin'" class="margin-right-10">{{ 'account/account' | ftc }}:
							<!-- глоб.фильтр -->
							<template v-if="$store.state.user_type === 'admin'">
								<font-awesome-icon v-if="!account['global_filter'] || account['global_filter']['value'] != account['account_id']['value']"
									class="global-filter-button"
									:title="'account/filter' | ftc"
									@click="setAccountGlobalFilter(account['account_id']['value'])"
									icon="filter"
								/>
								<font-awesome-layers v-if="account['global_filter'] && account['global_filter']['value'] == account['account_id']['value']"
									class="global-filter-button global-filter-button-remove"
									:title="'main/delete ' + localeFtc('main/filter').toLowerCase() | ftc"
									@click="setAccountGlobalFilter()">
									<font-awesome-icon icon="filter" />
									<font-awesome-icon icon="times" />
								</font-awesome-layers>
							</template>
							<!-- сама ссылка -->
							<linkComponent :url="'/account/view/' + account['account_id']['value']" :text="account['account_name']['value']" />
						</span>
						<span v-if="sshkey && sshkey['key_id'] && sshkey['key_id']['value'] && sshkey['key_name'] && sshkey['key_name']['value']" class="margin-right-10">
							<br class="visible-xs" />
							{{ 'sshkey/sshkey' | ftc }}: <linkComponent :url="'/sshkey/view/' + sshkey['key_id']['value']" :text="sshkey['key_name']['value']" />
						</span>
					</div>
				</div>

				<!-- ВКЛАДКИ -->
				<!-- навигация -->
				<ul class="nav nav-tabs margin-top-20">
					<li v-for="tab in tabs" v-if="tabVisible(tab.id)" :class="{ active: tab.id === curTab }" :key="tab.id">
						<a href="#" @click.stop.prevent="choiceTab(tab.id)">{{ tab.title | ftc }}</a>
					</li>
				</ul>
				<!-- содержимое -->
				<div class="tab-content">
					<tabCommand v-if="tabVisible('command')"
						class="tab-pane"
						:class="{ active: curTab === 'command' }"
						:access="Access"
						:status="serviceStatusClear"
						:serviceStatus="serviceStatus"
						:templateName="templateName"
						:vdsId="id"
						:canReboot="canReboot"
						:serviceName="serviceName"
						:iso="isoInfo"
						:serviceFullName="serviceFullName"
						:active="curTab === 'command'"
						:serviceProlong="serviceProlong"
						:serviceCanProlong="serviceCanProlong"
						:serviceCanDelete="serviceCanDelete"
						:templateInstruction="templateInstruction"
						:parentError="localErrorMessage"
						:reserveIpData="reserveIpData"
						@successMessage="onSuccessMessage"
						@updateData="updateData"
						@requestData="refreshVDSData" />

					<tabAccess v-if="tabVisible('access')"
						class="tab-pane"
						:class="{ active: curTab === 'access' }"
						:access="Access"
						:status="serviceStatusClear"
						:serviceStatus="serviceStatus"
						:vdsId="id"
						:vdsInfo="vdsData"
						:serviceFullName="serviceFullName"
						:templateName="templateName"
						:active="curTab === 'access'"
						:parentError="localErrorMessage"
						:passwordType="passwordType"
						@successMessage="onSuccessMessage" />

					<tabPlan v-if="tabVisible('plan')"
						class="tab-pane"
						:class="{ active: curTab === 'plan' }"
						:access="Access"
						:status="serviceStatusClear"
						:serviceStatus="serviceStatus"
						:vdsId="id"
						:plan="planInfo"
						:templateData="templateInfo"
						:value="servicePlanId"
						:parentError="localErrorMessage"
						@successMessage="onSuccessMessage"
						@dropPlanConstructorChanged="onDropPlanConstructorChanged" />

					<tabReinstall v-if="tabVisible('reinstall')"
						class="tab-pane"
						:class="{ active: curTab === 'reinstall' }"
						:access="Access"
						:status="serviceStatusClear"
						:serviceStatus="serviceStatus"

						:vdsId="id"

						:template="templateInfo"
						:host="hostInfo"
						:sshkey="sshkeyInfo"
						:account="account"
						:backup="backupInfo && backupInfo['backup_id'] ? backupInfo['backup_id'] : null"
						:reiso="reisoInfo"
						:dc="dataCenter"

						:planId="servicePlanId"
						:planData="planInfo"
						:value="serviceTemplateId"
						:parentError="localErrorMessage"
						:vdsName="serviceName"
						@successMessage="onSuccessMessage" />

					<tabIp v-if="tabVisible('ip')"
						class="tab-pane"
						:class="{ active: curTab === 'ip' }"
						:active="curTab === 'ip'"
						:status="serviceStatusClear"
						:serviceStatus="serviceStatus"
						:access="Access"
						:mainIP="serviceIPData"
						:ipInfo="ipInfo"
						:vdsId="id"
						:reserveIpData="reserveIpData"
						:reserveIPv4List="reserveIPv4List"
						:parentError="localErrorMessage"
						@successMessage="onSuccessMessage"
						@updateData="updateData"
						@flagCloseModals="value => notCloseModals = value" />

					<tabLocalIp v-if="tabVisible('localIp')"
						class="tab-pane"
						:class="{ active: curTab === 'localIp' }"
						:status="serviceStatusClear"
						:serviceStatus="serviceStatus"
						:access="Access"
						:data="serviceLocalIPData"
						:vdsId="id"
						:ipLocalData="ipLocalData"
						:parentError="localErrorMessage" />

					<tabBackup v-if="tabVisible('backup')"
						class="tab-pane"
						:class="{ active: curTab === 'backup' }"
						:active="curTab === 'backup'"
						:serviceStatus="serviceStatus"
						:access="Access"
						:backup="backupInfo && backupInfo['create'] ? backupInfo['create'] : null"
						:backupList="backupInfo && backupInfo['backup_id'] ? backupInfo['backup_id'] : null"
						:vdsId="id"
						:vdsName="serviceName"
						:account="account"
						:planInfo="servicePlanInfo"
						:parentError="localErrorMessage"
						@successMessage="onSuccessMessage"
						@updateData="updateData" />

					<tabDisks v-if="tabVisible('disks')"
						class="tab-pane"
						:class="{ active: curTab === 'disks' }"
						:active="curTab === 'disks'"
						:serviceStatus="serviceStatus"
						:access="Access"
						:vdsId="id"
						:vdsName="serviceName"
						:account="account"
						:dc="dataCenter"
						:parentError="localErrorMessage"
						@successMessage="onSuccessMessage"
						@updateData="updateData" />

					<tabStat v-if="tabVisible('stat') && !localErrorMessage"
						class="tab-pane"
						:class="{ active: curTab === 'stat' }"
						:active="curTab === 'stat'"
						:planInfo="servicePlanInfo"
						:trafInfo="trafInfo"
						:localIpInfo="serviceLocalIPData"
						:vdsId="id" />
				</div>

				<!-- диалог изменения названия -->
				<transition name="modal">
					<div v-show="showNameModal" @mousedown="maskModalFlag = true" @mouseup="() => this.hideNameModal(false)" class="modal-mask">
						<div class="modal-wrapper">
							<div class="modal-container" @mousedown.stop="maskModalFlag = false" @mouseup.stop="maskModalFlag = false">

								<!-- заголовок -->
								<div class="modal-header">
									<span class="font-weight-500">{{ 'main/name' | ftc }}</span>
									<button type="button" class="close" @click="hideNameModal">&times;</button>
								</div>

								<!-- тело диалога -->
								<div class="modal-body">
									<div class="w5-form-row">
										<Field
											:isVisibleRow="true"
											crud="vds"
											action="view"
											v-model="nameValue"
											:Field="nameField"
											:removeRightPadding="true"
											:fieldInModal="true"
											@focus="onFocusName"
											@enterKeyDown="nameChangeStart" />
									</div>
								</div>

								<!-- подвал -->
								<div class="modal-footer">
									<span class="btn btn-submit pull-right" @click="nameChangeStart">{{ 'service/rename_action' | ftc }}</span>
								</div>
							</div>
						</div>
					</div>
				</transition>

			</div>
			<!-- ===================================== -->

			<!-- блок с локальным сообщением об успехе -->			
			<transition name="fallingBlock" key="transitionSuccess">
				<div v-show="localSuccessMessage !== ''" class="alert alert-success font-size-90 falling-block" role="alert" style="margin-right: 10px; word-break: break-word;">
					<button @click="localSuccessMessage = ''" class="close" :title="'main/close' | ftc">×</button>
					{{ localSuccessMessage | ftc }}
				</div>
			</transition>

		</template>

		<errorAlert v-else :message="form_ErrorMessage" />

	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
import tabCommand from '@/components/vds/command'
import tabAccess from '@/components/vds/access'
import tabPlan from '@/components/vds/plan'
import tabReinstall from '@/components/vds/reinstall'
import tabIp from '@/components/vds/ip'
import tabLocalIp from '@/components/vds/localIp'
import tabBackup from '@/components/vds/backup'
import tabDisks from '@/components/vds/disk'
import tabStat from '@/components/vds/stat'
import { EventBus } from '../../bus.js'
import Field from '@/components/elements/formfield'
import debounce from 'debounce'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование компонента
	//=========================================================================
	name: 'vdsView',
	//=========================================================================
	//
	//=========================================================================
	data() {
		return {
			// наименование CRUD
			crud: 'vds',

			// ID vds
			id: null,

			// локальное сообщение об ошибке
			localErrorMessage: '',
			localSuccessMessage: '',
			localSuccessMessageTimer: null,

			// кешированные данные для просмотра
			vdsData: {},

			// кеш данных о тарифных планах
			planData: null,
			// кеш данных о шаблонах (что бы знать URL по которому запрашивать данные)
			templateData: null,
			// кеш данных о наименовании хоста
			hostData: null,
			// кеш данных о ssh-ключах
			sshkeyData: null,
			// кеш данных о снимках
			snapshotData: null,
			// кеш данных о бэкапах
			backupData: null,
			// кеш данных о установочных ISO
			reisoData: null,
			// кеш данных со списком ISO
			isoList: null,
			isoFieldFirst: null,
			isoFieldSecond: null,
			// кеш заголовков полей ISO
			isoFieldsTitles: null,
			// кеш по IP-адресам
			ipData: null,
			// кеш по локальным IP-адресам
			ipLocalData: null,
			// кеш по типам пароля
			passwordType: null,
			// кеш по полю резервирования IP-адреса
			reserveIpData: null,
			// кеш по полю уже зарезервированных IP-адресов
			reserveIPv4List: null,

			// вкладки
			tabs: [
				// управление
				{ 'id': 'command', 'title': 'service/vds_control' },
				// доступ
				{ 'id': 'access', 'title': 'main/access' },
				// тариф
				{ 'id': 'plan', 'title': 'plan/plan' },
				// переустановка
				{ 'id': 'reinstall', 'title': 'service/reinstall' },
				// IP
				{ 'id': 'ip', 'title': 'service/ip_count' },
				// local IP
				{ 'id': 'localIp', 'title': 'datacenter/local_net' },
				// снимки
				//{ 'id': 'snapshot', 'title': 'service/snapshots' },
				// бэкапы
				{ 'id': 'backup', 'title': 'service/backups' },
				// внешние диски
				{ 'id': 'disks', 'title': 'service/extdisks' },
				// статистика
				{ 'id': 'stat', 'title': 'service/stat' }
			],
			// текущая вкладка
			curTab: 'command',

			// переименование
			showNameModal: false,
			nameValue: '',
			nameField: {
				required: true,
				type: 'text',
				title: 'main/name',
				_field_name: 'serviceName',
				_visible: true,
				_errMsg: ''
			},

			// изменился ли тариф-конструктор
			isConstructPlanChanged: false,

			// флаг - не закрывать модальный диалог
			notCloseModals: false
		}
	},
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		localErrorMessageClear() {
			if (this.localErrorMessage === undefined ||
				this.localErrorMessage === null ||
				this.localErrorMessage === '')
				return ''
			if (this.localErrorMessage.charAt(0) === 'x') return this.localErrorMessage.substr(1)
			return this.localErrorMessage
		},
		localErrorMessageButton() {
			if (this.localErrorMessage === undefined ||
				this.localErrorMessage === null ||
				this.localErrorMessage === '')
				return false
			if (this.localErrorMessage.charAt(0) === 'x') return false
			return true
		},
		// готовы ли данные для отображения
		isDataReady() {
			return this.isCorrectData(this.vdsData)
		},
		// если ли доступ к редактированию VDS
		Access() {
			// если есть процесс
			if (this.vdsData['service']['service_status']['text'] &&
				String(this.vdsData['service']['service_status']['text']).length)
			{
				// если при этом статус не активен - сразу закрываем доступ
				if (this.vdsData['service']['service_status']['value'] !== 'active')
					return false
			}
			// если есть процесс или в очереди
			if (this.serviceStatus && (this.serviceStatus.loader || this.serviceStatus.timer))
			{
				return false
			}
			// иначе - права по умолчанию
			return this.isAccess('service/update')
		},
		// конкретные данные
		serviceName() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_name'] &&
				'value' in this.vdsData['service']['service_name'])
				return this.vdsData['service']['service_name']['value']

			return null
		},
		serviceFullName() {
			let _fullName = this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_name'] && 'value' in this.vdsData['service']['service_name'] ? this.vdsData['service']['service_name']['value'] : ''
			if (this.vdsData && this.vdsData['title'])
			{
				let _search = this.vdsData['title'].match(/«(.*)»/i)
				if (_search !== null && _search.length) _fullName = this.localeFtc(_search[1])
			}

			return _fullName
		},
		dataCenter() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_data'] &&
				this.vdsData['service']['service_data']['value'] &&
				this.vdsData['service']['service_data']['value']['datacenter'])
				return this.vdsData['service']['service_data']['value']['datacenter']

			return null
		},
		serviceIP() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_data'] &&
				this.vdsData['service']['service_data']['value'] &&
				this.vdsData['service']['service_data']['value']['ip'] &&
				this.vdsData['service']['service_data']['value']['ip']['ip'])
				return this.vdsData['service']['service_data']['value']['ip']['ip']

			return ''
		},
		serviceIPActive() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_data'] &&
				this.vdsData['service']['service_data']['value'] &&
				this.vdsData['service']['service_data']['value']['ip'] &&
				'active' in this.vdsData['service']['service_data']['value']['ip'])
				return Boolean(this.vdsData['service']['service_data']['value']['ip']['active'])

			return true
		},
		serviceStatus() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_status'])
				return Helper.cellStatusInView(this.vdsData['service']['service_status'])

			return null
		},
		serviceStatusClear() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_status'] &&
				'value' in this.vdsData['service']['service_status'])
				return this.vdsData['service']['service_status']['value']

			return null
		},
		serviceTemplate() {
			if (this.vdsData && this.vdsData['template'])
				return this.vdsData['template']

			return null
		},
		templateName() {
			if (this.vdsData &&
				this.vdsData['template'] &&
				this.vdsData['template']['template_name'] &&
				'value' in this.vdsData['template']['template_name'])
				return this.vdsData['template']['template_name']['value']

			return null
		},
		templateInstruction() {
			if (this.vdsData &&
				this.vdsData['template'] &&
				this.vdsData['template']['template_instruction'])
				return this.vdsData['template']['template_instruction']

			return null
		},
		templateInfo() {
			if (this.templateData) return this.templateData
			return null
		},
		reisoInfo() {
			if (this.reisoData) return this.reisoData
			return null
		},
		serviceTemplateId() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_data'] &&
				this.vdsData['service']['service_data']['value'] &&
				this.vdsData['service']['service_data']['value']['template'] &&
				this.vdsData['service']['service_data']['value']['template']['id'])
				return this.vdsData['service']['service_data']['value']['template']['id']

			return null
		},
		servicePlanInfo() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_data'] &&
				this.vdsData['service']['service_data']['value'] &&
				this.vdsData['service']['service_data']['value']['plan'] &&
				this.vdsData['service']['service_data']['value']['plan']['data'])
				return this.vdsData['service']['service_data']['value']['plan']['data']

			return null
		},
		planInfo() {
			if (this.planData) return this.planData
			return null
		},
		servicePlanId() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_data'] &&
				this.vdsData['service']['service_data']['value'] &&
				this.vdsData['service']['service_data']['value']['plan'] &&
				this.vdsData['service']['service_data']['value']['plan']['id'])
				return this.vdsData['service']['service_data']['value']['plan']['id']

			return null
		},
		serviceProlong() {
			return this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_autoprolong'] &&
				'value' in this.vdsData['service']['service_autoprolong'] ? this.vdsData['service']['service_autoprolong']['value'] : null
		},
		serviceCanProlong() {
			return this.vdsData && this.vdsData['service'] && this.vdsData['service']['can_prolong'] === true
		},
		serviceCanDelete() {
			let _canDel = false
			// определим если есть точное указание в записи
			if (this.vdsData && this.vdsData['service'] && 'can_delete' in this.vdsData['service'])
			{
				// есть поле "can_delete", смотрим на его значение
				_canDel = Helper.normalizeBooleanValue(this.vdsData['service']['can_delete'])
			}
			else
			{
				// прямого указания нет - считаем что запись можно удалять
				_canDel = true
				// ищем статус записи
				if (this.vdsData && this.vdsData['service'] && this.vdsData['service']['service_status'] && 'value' in this.vdsData['service']['service_status'] &&
					String(this.vdsData['service']['service_status']['value']).indexOf('delete') >= 0)
				{
					// нашли такое поле - значит запись со статусом "удалена"
					_canDel = false
				}
			}

			return _canDel
		},
		account() {
			return this.vdsData && this.vdsData['account'] ? this.vdsData['account'] : null
		},
		hostInfo() {
			if (this.hostData) return this.hostData
			return null
		},
		sshkey() {
			return this.vdsData && this.vdsData['sshkey'] ? this.vdsData['sshkey'] : null
		},
		sshkeyInfo() {
			if (this.sshkeyData) return this.sshkeyData
			return null
		},
		canReboot() {
			return this.vdsData && this.vdsData['service'] && 'can_reboot' in this.vdsData['service'] ? this.vdsData['service']['can_reboot'] : false
		},
		canIpLocal() {
			return this.vdsData && this.vdsData['service'] && 'can_ip_local' in this.vdsData['service'] ? this.vdsData['service']['can_ip_local'] : false
		},
		canBackup() {
			return this.vdsData && this.vdsData['service'] && 'can_backup' in this.vdsData['service'] ? this.vdsData['service']['can_backup'] : false
		},
		canDisks() {
			return this.vdsData && this.vdsData['service'] && 'can_extdisk' in this.vdsData['service'] ? this.vdsData['service']['can_extdisk'] : false
		},
		trafInfo() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_traff'])
				return this.vdsData['service']['service_traff']

			return null
		},
		snapshotInfo() {
			if (this.snapshotData) return this.snapshotData
			return null
		},
		backupInfo() {
			if (this.backupData) return this.backupData
			return null
		},
		isoInfo() {
			return this.vdsData && this.vdsData['iso'] ? this.vdsData['iso'] : null
		},
		isoData() {
			return this.isoList
		},
		serviceIPData() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_data'] &&
				this.vdsData['service']['service_data']['value'] &&
				this.vdsData['service']['service_data']['value']['ip'])
				return this.vdsData['service']['service_data']['value']['ip']

			return null
		},
		serviceLocalIPData() {
			if (this.vdsData &&
				this.vdsData['service'] &&
				this.vdsData['service']['service_data'] &&
				this.vdsData['service']['service_data']['value'] &&
				this.vdsData['service']['service_data']['value']['local_ip'])
				return this.vdsData['service']['service_data']['value']['local_ip']

			return ''
		},
		ipInfo() {
			return this.ipData
		},
		isAccountBlockVisible() {
			if (this.$store.state.user_type === 'admin')
				return true

			if (this.sshkey && this.sshkey['key_id'] && this.sshkey['key_id']['value'] && this.sshkey['key_name'] && this.sshkey['key_name']['value'])
				return true

			return false
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		this.maskModalFlag = false

		// запрос на рефреш данных от вкладок - могут приходить несколько подряд
		this.refreshVDSData = debounce(this.refreshVDSData, 500)
		this.makeRequestForUpdateDataDebounce = debounce(this.makeRequestForUpdateDataDebounce, 1500, false)

		// получим ID vds
		this.id = this.$route.params['id']
		if (this.id)
		{
			// теперь можно запросить данные
			this.requestVDSData()
		}
		else
		{
			this.localErrorMessage = this.localeFtc('main/unknown_page')
		}

		// если есть команда перехода
		if (this.$store.state.vdsCommand &&
			String(this.$store.state.vdsCommand['id']) === String(this.id) &&
			(
				this.$store.state.vdsCommand['command'] === 'plan' ||
				this.$store.state.vdsCommand['command'] === 'reinstall' ||
				this.$store.state.vdsCommand['command'] === 'password'
			))
		{
			// выбираем соответствующую вкладку
			let _command = this.$store.state.vdsCommand['command']
			let callFunction = null
			if (_command === 'password')
			{
				_command = 'access'
				callFunction = 'changePassword'
			}

			this.$nextTick(() => {
				// если нужно вызвать какую то функцию во вкладке
				if (callFunction) window.sessionStorage.setItem('callFunction', callFunction)
				// переключаем на вкладку
				this.choiceTab(_command)
			})
			// обнулим команду
			this.$store.commit('setVdsCommand', false)
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
		// есть ли изменения в конструкторе
		EventBus.$on('w5-plan-constructor-changed', this.handlePlanConstructorChanged)
		// закрытие вкладки или рефреш
		window.onbeforeunload = this.onBeforeUnload

		window.addEventListener('storage', this.onLocalStorageEvent)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)
		document.removeEventListener('keydown', this.keyDownHandler)
		EventBus.$off('w5-plan-constructor-changed', this.handlePlanConstructorChanged)
		window.removeEventListener('storage', this.onLocalStorageEvent)
		window.onbeforeunload = null
	},
	//=========================================================================
	// обработчик: перед переходом по URL
	//=========================================================================
	beforeRouteLeave(to, from, next) {
		next(this.onBeforePopState())
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// запрос данных для просмотра
		//---------------------------------------------------------------------
		requestVDSData(refreshCache) {
			// еще раз проверим ID
			if (!this.id)
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// теперь точно можно делать запрос
			this.$http.get(this.APIServerUrl + '/service/view/' + this.id).then(
				// успешный ответ
				respons => {
					// получаем ответ
					let _dt = respons && respons.data && typeof respons.data === 'object' ? respons.data : false
					// возможно сервис уже удален
					if (_dt && _dt['status'] === 'ok' &&
						_dt['service'] && _dt['service']['service_status'] &&
						_dt['service']['service_status']['value'] === 'deleted')
					{
						// это ошибка
						this.localErrorMessage = 'x<b>service/status_error:</b><br> service/deleted'
						return
					}
					// возможно сервис с ошибкой
					if (_dt && _dt['status'] === 'ok' &&
						_dt['service'] && _dt['service']['service_status'] &&
						_dt['service']['service_status']['value'] === 'error')
					{
						// это ошибка
						this.localErrorMessage = 'x<b>service/status_error:</b><br> error/api_incorrect'
						return
					}
					// если ответ корректный
					if (this.isCorrectData(_dt))
					{
						// запоминаем данные по VDS
						this.vdsData = _dt

						// запоним текущую группу VDS в хранилище если она указана
						if (this.vdsData['group'] && this.vdsData['group']['group_id'] && this.vdsData['group']['group_id']['value'])
							this.$store.commit('setVdsGroupId', this.vdsData['group']['group_id']['value'])

						// если таб на которым мы были вдруг стал невидимым
						if (!this.tabVisible(this.curTab)) this.curTab = 'command'

						// если требуется рефреш
						if (refreshCache)
						{
							// обнуляем кеш
							this.planData = null
							this.templateData = null
							this.reisoData = null
							this.snapshotData = null
							this.backupData = null
							this.ipData = null
							this.passwordType = null
							// теперь просто включим текущую вкладку
							//this.choiceTab(this.curTab)
							// ! тут нужен только рефреш данных из service/update
							this.requestUpdateData(false, true)
						}

						// на этом все
						return
					}

					// ошибка - некорректный ответ
					this.form_ErrorMessage = this.localeFtc('error/api_incorrect')
				},
				// отрицательный ответ
				respons => {
					// ошибка ответа сервера
					this.form_ErrorMessage = this.localeFtc('error/api_incorrect')
				}
			)
		},
		//---------------------------------------------------------------------
		// проверка ответа сервера
		//---------------------------------------------------------------------
		isCorrectData(data) {
			if (this.$store.state.user_type === 'admin') return this.isCorrectDataForAdmin(data)
			if (this.$store.state.user_type === 'client') return this.isCorrectDataForClient(data)
			return false
		},
		//---------------------------------------------------------------------
		// проверка ответа сервера для сотрудника
		//---------------------------------------------------------------------
		isCorrectDataForAdmin(data) {
			if (!data || data['status'] !== 'ok' ||
				!data['account'] ||
				//!data['ippool'] ||
				!data['plan'] ||
				!data['server'] ||
				!data['service'] ||
				!data['service_type'] ||
				!data['template'])
				return false

			// наименование VDS
			if (!data['service']['service_name'] ||
				!data['service']['service_name']['value'])
				return false

			// статус VDS
			if (!data['service']['service_status'] ||
				!data['service']['service_status']['value'])
				return false

			// дата-центр
			if (!data['service']['service_data'] ||
				!data['service']['service_data']['value'] ||
				!data['service']['service_data']['value']['datacenter'] ||
				!data['service']['service_data']['value']['datacenter']['country'])
				return false

			// IP
			/*
			if (!data['service']['service_data'] ||
				!data['service']['service_data']['value'] ||
				!data['service']['service_data']['value']['ip'] ||
				!data['service']['service_data']['value']['ip']['ip'])
				return false
			*/

			// аккаунт
			if (!data['account']['account_id'] || !data['account']['account_id']['value'] ||
				!data['account']['account_name'] || !data['account']['account_name']['value'])
				return false

			// шаблон
			if (!data['template']['template_id'] || !data['template']['template_id']['value'] ||
				!data['template']['template_image'] || !data['template']['template_image']['value'] ||
				!data['template']['template_name'] || !data['template']['template_name']['value'])
				return false

			// информация о тарифном плане
			if (!data['service']['service_data'] ||
				!data['service']['service_data']['value'] ||
				!data['service']['service_data']['value']['plan'] ||
				!data['service']['service_data']['value']['plan']['data'])
				return false

			return true
		},
		//---------------------------------------------------------------------
		// проверка ответа сервера для клиента
		//---------------------------------------------------------------------
		isCorrectDataForClient(data) {
			if (!data || data['status'] !== 'ok' ||
				//!data['ippool'] ||
				!data['plan'] ||
				!data['service'] ||
				!data['service_type'] ||
				!data['template'])
				return false

			// наименование VDS
			if (!data['service']['service_name'] ||
				!data['service']['service_name']['value'])
				return false

			// статус VDS
			if (!data['service']['service_status'] ||
				!data['service']['service_status']['value'])
				return false

			// дата-центр
			if (!data['service']['service_data'] ||
				!data['service']['service_data']['value'] ||
				!data['service']['service_data']['value']['datacenter'] ||
				!data['service']['service_data']['value']['datacenter']['country'])
				return false

			// IP
			/*
			if (!data['service']['service_data'] ||
				!data['service']['service_data']['value'] ||
				!data['service']['service_data']['value']['ip'] ||
				!data['service']['service_data']['value']['ip']['ip'])
				return false
			*/

			// шаблон
			if (!data['template']['template_id'] || !data['template']['template_id']['value'] ||
				!data['template']['template_image'] || !data['template']['template_image']['value'] ||
				!data['template']['template_name'] || !data['template']['template_name']['value'])
				return false

			// информация о тарифном плане
			if (!data['service']['service_data'] ||
				!data['service']['service_data']['value'] ||
				!data['service']['service_data']['value']['plan'] ||
				!data['service']['service_data']['value']['plan']['data'])
				return false

			return true
		},
		//---------------------------------------------------------------------
		// выбор текущей вкладки
		//---------------------------------------------------------------------
		choiceTab(id) {
			// если у нас измененный конструктор - нужно переспрашивать
			if (this.curTab === 'plan')
			{
				if (!this.onBeforePopState()) return
			}

			// если выбрали вкладку с тарифом или шаблоном, а данных еще нет
			if ((!this.planData || !this.templateData || !this.snapshotData || !this.backupData || !this.reisoData || !this.ipData || !this.ipLocalData || !this.isoList || !this.passwordType || !this.reserveIpData || !this.reserveIPv4List) &&
				(id === 'plan' || id === 'reinstall' || id === 'snapshot' || id === 'backup' || id === 'ip' || id === 'localIp' || id === 'command' || id === 'access'))
			{
				// делаем запрос на редактирование VDS - в ответе есть нужные данные
				// без кеширования и без дебаунса
				this.requestUpdateData()
			}

			// если выбрали вкладку с шаблоном - нужно перегенерировать список шаблонов
			if (id === 'reinstall') this.requestTemplatesList()

			// выдялем текущую вкладку
			this.curTab = id
		},
		//---------------------------------------------------------------------
		// запрос данных service/update
		//---------------------------------------------------------------------
		requestUpdateData(data, withDebounce = false) {
			if (data)
			{
				this.saveToCache(data)
				return
			}
			// делаем запрос на редактирование VDS - в ответе есть нужные данные
			if (withDebounce)
				this.makeRequestForUpdateDataDebounce()
			else
				this.makeRequestForUpdateData()
		},
		//---------------------------------------------------------------------
		// сам запрос
		//---------------------------------------------------------------------
		makeRequestForUpdateData() {
			// не делаем запрос если сервис заблокирован или вообще удален
			if (this.serviceStatusClear === 'block' ||
				this.serviceStatusClear === 'deleted' ||
				this.serviceStatusClear === 'new')
			{
				return
			}

			// если идет процесс удаления вдс
			if (this.vdsData['service'] &&
				this.vdsData['service']['service_status'] &&
				this.vdsData['service']['service_status']['text'] &&
				String(this.vdsData['service']['service_status']['text']).length &&
				String(this.vdsData['service']['service_status']['text']).indexOf('type_delete') > 0)
			{
				return
			}

			this.$http.get(this.APIServerUrl + '/service/update/' + this.id).then(
				// рассматриваем только положительный ответ
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					if (_dt && _dt['status'] === 'form' && _dt['fields'] &&
						_dt['fields']['plan_id'] && _dt['fields']['template_id'])
					{
						this.saveToCache(_dt)
					}
				}
			).catch(() => {
				if (this.$store.state.isDebug) window.DEBUG.error('vdsView (rud01): запрос вернул ошибку')
			})
		},
		makeRequestForUpdateDataDebounce() {
			this.$http.get(this.APIServerUrl + '/service/update/' + this.id).then(
				// рассматриваем только положительный ответ
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					if (_dt && _dt['status'] === 'form' && _dt['fields'] &&
						_dt['fields']['plan_id'] && _dt['fields']['template_id'])
					{
						this.saveToCache(_dt)
					}
				}
			).catch(() => {
				if (this.$store.state.isDebug) window.DEBUG.error('vdsView (rud01): запрос вернул ошибку')
			})
		},
		//---------------------------------------------------------------------
		// запоминание кеша
		//---------------------------------------------------------------------
		saveToCache(data) {
			let _dt = data
			if (_dt && _dt['status'] === 'form' && _dt['fields'] &&
				_dt['fields']['plan_id'] && _dt['fields']['template_id'])
			{
				// запоминаем в кеш данные сервера
				this.planData = _dt['fields']['plan_id']
				this.templateData = _dt['fields']['template_id']
				this.hostData = _dt['fields']['hostname']
				this.sshkeyData = _dt['fields']['sshkey_id']
				this.snapshotData = _dt['fields']['snapshot_create']
				this.isoList = this.makeIsoList(_dt)
				this.isoFieldFirst = _dt['fields']['iso_id'] ? _dt['fields']['iso_id'] : null
				this.isoFieldSecond = _dt['fields']['iso_secondary_id'] ? _dt['fields']['iso_secondary_id'] : null
				this.reisoData = _dt['fields']['reiso_id']
				this.ipLocalData = _dt['fields']['ip_local'] ? _dt['fields']['ip_local'] : null
				this.reserveIpData = _dt['fields']['reserve_ip'] ? _dt['fields']['reserve_ip'] : null
				this.reserveIPv4List = _dt['fields']['use_reserve_ip'] ? _dt['fields']['use_reserve_ip'] : null

				this.isoFieldsTitles = {}
				if (_dt['fields']['iso_id'] && _dt['fields']['iso_id']['title']) {
					this.isoFieldsTitles['iso_id'] = _dt['fields']['iso_id']['title']
				}
				if (_dt['fields']['iso_secondary_id'] && _dt['fields']['iso_secondary_id']['title']) {
					this.isoFieldsTitles['iso_secondary_id'] = _dt['fields']['iso_secondary_id']['title']
				}

				// данные по IP-адресам
				this.ipData = null
				if (_dt['fields']['ip4_count'])
				{
					this.ipData = {
						'ip4': {
							'cost': _dt['fields']['ip4_count']['cost'],
							'for': _dt['fields']['ip4_count']['for'],
							'max': _dt['fields']['ip4_count']['max'],
							'period': _dt['fields']['ip4_count']['period'],
							'count': _dt['fields']['ip4_count']['value']
						}
					}
				}

				if (_dt['fields']['ip6_count'])
				{
					if (!this.ipData) this.ipData = {}
					this.ipData['ip6'] = {
						'cost': _dt['fields']['ip6_count']['cost'],
						'for': _dt['fields']['ip6_count']['for'],
						'max': _dt['fields']['ip6_count']['max'],
						'period': _dt['fields']['ip6_count']['period'],
						'count': _dt['fields']['ip6_count']['value']
					}
				}

				// данные по бэкапу
				this.backupData = null
				if (_dt['fields']['backup_create'])
				{
					this.backupData = {
						'create': _dt['fields']['backup_create']
					}
				}

				if (_dt['fields']['backup_id'])
				{
					if (!this.backupData) this.backupData = {}
					this.backupData['backup_id'] = _dt['fields']['backup_id']
				}

				// данные по типу пароля
				this.passwordType = null
				if (_dt['fields']['password_type'] && _dt['fields']['password_type']['list']) {
					this.passwordType = _dt['fields']['password_type']['list']
				}

				// дополнительные данные
				this.planData['_visible'] = true
				this.planData['_field_name'] = 'plan_id'
				this.planData['_errMsg'] = ''

				this.templateData['_visible'] = true
				this.templateData['_field_name'] = 'template_id'
				this.templateData['_errMsg'] = ''
				// сразу запросим список шаблонов
				if (this.curTab === 'reinstall') this.requestTemplatesList()

				this.hostData['_visible'] = true
				this.hostData['_field_name'] = 'hostname'
				this.hostData['_errMsg'] = ''

				this.sshkeyData['_visible'] = true
				this.sshkeyData['_field_name'] = 'sshkey_id'
				this.sshkeyData['_errMsg'] = ''

				// ищем в списке - есть ли уже пустое значение
				let _found = this.sshkeyData['list'].some(obj => (obj && String(obj.id) === '-1000'))

				// добавим пустое значение
				if (!_found)
				{
					this.sshkeyData['list'].unshift({
						//'id': 'emptyValue',
						'id': -1000,
						'name': this.localeFtc('sshkey/not_use')
					})
				}

				// отключаем текущий план
				// если это простой план, не конструктор - в нем есть список
				if (this.planData &&
					this.planData['list'] &&
					Array.isArray(this.planData['list']) &&
					this.planData['list'].length)
				{
					this.planData['list'].some((item, index, arr) => {
						if (String(item.id) === String(this.servicePlanId))
						{
							arr[index]['enable'] = false
							return true
						}
					})
				}
			}
		},
		//---------------------------------------------------------------------
		// если пришло события запроса данных UPDATE
		//---------------------------------------------------------------------
		updateData(data) {
			// если VDS заблокирована или неоплачена
			if (this.serviceStatusClear !== 'active' || !this.Access)
			{
				this.reserveIpData = false
				return
			}

			const isDebounce = this.curTab !== 'command' && this.curTab !== 'ip'
			this.requestUpdateData(data, isDebounce)
		},
		//---------------------------------------------------------------------
		// запрос списка шаблогов для переустановки
		//---------------------------------------------------------------------
		requestTemplatesList() {
			// проверка данных
			if (!this.templateData || !this.templateData['url'] || !this.servicePlanId) return

			// данные есть - формируем URL для запроса
			let _url = this.APIServerUrl + this.templateData['url'] + this.servicePlanId
			// делаем запрос
			this.$http.get(_url).then(
				// рассматриваем только положительный ответ
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					if (_dt && _dt['status'] === 'ok' && _dt['result'] && Array.isArray(_dt['result']) && _dt['result'].length)
					{
						this.$set(this.templateData, 'list', _dt['result'])
						//Helper.prepareTemplateList(this.templateData)
					}
				}
			)
		},
		//---------------------------------------------------------------------
		// запрос списка внешних дисков
		//---------------------------------------------------------------------
		requestExtDisks() {

		},
		//---------------------------------------------------------------------
		// видима ли вкладка
		//---------------------------------------------------------------------
		tabVisible(id) {
			if (this.serviceStatusClear !== 'active')
			{
				if (id === 'plan' || id === 'reinstall' || id === 'snapshot' || id === 'backup' || id === 'disks' || id === 'access' || id === 'ip' || id === 'localIp')
					return false
			}

			if (id === 'localIp' && !this.canIpLocal) return false
			if (id === 'backup' && !this.canBackup) return false
			if (id === 'disks' && !this.canDisks) return false

			if (id === 'stat') return this.isAccess('service/stat')
			if (id === 'snapshot' || id === 'backup' || id === 'disks' || id === 'ip' || id === 'localIp') return this.isAccess('service/update')

			return true
		},
		//---------------------------------------------------------------------
		// смена наименования VDS
		//---------------------------------------------------------------------
		// вызов диалога смены названия
		async changeServiceName() {
			// проверка доступа
			if (!this.Access) return
			if (this.serviceStatus['loader'] === true || this.serviceStatus['timer'] === true) return
			if (this.serviceStatusClear !== 'active') return

			// обновим значение
			this.nameValue = this.serviceName
			this.nameField._errMsg = ''
			this.localErrorMessage = ''
			this.localSuccessMessage = ''

			// запросим значение
			const result = await this.$http.get(this.APIServerUrl + '/service/update/' + this.id)
			let _dt = result && result.data && typeof result.data === 'object' ? result.data : false
			if (_dt &&
				_dt['_csrf'] &&
				_dt['model'] &&
				_dt['status'] === 'form' &&
				_dt['fields'] &&
				'name' in _dt['fields'] &&
				_dt['fields']['name'] &&
				'value' in _dt['fields']['name'] &&
				_dt['fields']['name']['value'])
			{
				this.nameValue = _dt['fields']['name']['value']
			}

			// покажем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showNameModal = true
		},
		// скрыт диалог
		hideNameModal(forceClose = true) {
			if (!forceClose)
			{
				// если это просто выход мыши за пределы даилога, например
				// при выделении мышью
				if (!this.maskModalFlag) return
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showNameModal = false
			this.hideModalMask()
		},
		// фокус на поле
		onFocusName() {
			this.nameField['_errMsg'] = ''
		},
		// изменение наименования
		nameChangeStart() {
			// проверка доступа
			if (!this.Access) return
			// если есть ошибка
			if (this.nameField['_errMsg'] !== '') return
			// проверка значения
			if (!this.nameValue || this.nameValue.trim() === '')
			{
				this.nameField['_errMsg'] = 'validators/error_req'
				return
			}

			// все в порядке - начинаем менять название
			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.id
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {
							'name': this.nameValue.trim(),
							'reinstall': 0
						}
						// проверка - если поля не изменились
						if ('fields' in _dt && _dt['fields'] && 'name' in _dt['fields'] && _dt['fields']['name'] && 'value' in _dt['fields']['name'] &&
							_dt['fields']['name']['value'] === this.nameValue.trim())
						{
							// закроем диалог
							this.hideNameModal()
							// на этом все
							return
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// закроем диалог
									this.hideNameModal()
									// установим успешное сообщение
									this.setLocalSuccessMessage('main/updated')
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error')
								{
									// ошибка по умолчанию
									this.nameField['_errMsg'] = this.localeFtc('main/validation_error')
									// если что то передали
									if (_dt['fields'] && _dt['fields']['name'])
									{
										if (Array.isArray(_dt['fields']['name']))
										{
											if (_dt['fields']['name'].length)
												this.nameField['_errMsg'] = this.localeFtc(_dt['fields']['name'][0])
										}
										else
										{
											this.nameField['_errMsg'] = this.localeFtc(_dt['fields']['name'])
										}
									}
									return
								}

								// закроем диалог
								this.hideNameModal()
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// закроем диалог
								this.hideNameModal()
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// закроем диалог
					this.hideNameModal()
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// закроем диалог
					this.hideNameModal()
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// обработка нажатия клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие диалога
			if (e.keyCode === 27)
			{
				e.preventDefault()

				// если есть запрет закрытия диалогов
				// его может дать вкладка с IP-адресами,
				// когда активен один из диалогов - создание, редактирование, удаление
				if (this.notCloseModals) return

				// просто закрываем диалог
				this.hideNameModal()
			}
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			if (!_parts || _parts.length < 3) return

			// сообщение нужно обработать только если совпадает CRUD
			if (_parts[1] !== this.getRealCrud(this.crud)) return

			// получим ID
			let _id = _parts[2]
			// если не задан ID - ничего не делаем
			if (!_id) return

			// если это ID VDS
			let _isVDS = String(_id) === String(this.id)

			// если это ID ISO
			let _isISO = this.isoInfo && this.isoInfo['service_id'] && this.isoInfo['service_id']['value'] && String(this.isoInfo['service_id']['value']) === String(_id)

			// если это ID SSH
			let _isSSH = this.sshkey && this.sshkey['key_id'] && this.sshkey['key_id']['value'] && String(this.sshkey['key_id']['value']) === String(_id)

			// обновляем данные, пришедшие с сервера
			// данные внутри компонента "viewComponent" автоматически
			// обновятся по наблюдателю (watch)
			if (_isVDS || _isISO || _isSSH) this.requestVDSData(true)
		},
		//---------------------------------------------------------------------
		// если потомок запросил рефреш данных
		//---------------------------------------------------------------------
		refreshVDSData() {
			// запрос данных с обнулением кеша
			this.requestVDSData(true)
		},
		//---------------------------------------------------------------------
		// обработчик события - приход успешного сообщения
		//---------------------------------------------------------------------
		onSuccessMessage(msg) {
			this.setLocalSuccessMessage(msg)
		},
		//---------------------------------------------------------------------
		// установка успешного сообщения
		//---------------------------------------------------------------------
		setLocalSuccessMessage(msg) {
			EventBus.$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			})
		},
		//---------------------------------------------------------------------
		// установка/снятие глобального фильтра по аккаунту
		//---------------------------------------------------------------------
		setAccountGlobalFilter(account) {
			// если это не сотрудник
			if (this.$store.state.user_type !== 'admin') return

			// если это установка фильтра
			if (account)
			{
				if (!/\d+/.test(account)) return
				let _accountID = parseInt(account)
				if (isNaN(_accountID) || _accountID < 1) return

				// начинаем установку фильтра - готовим параметры и URL
				let _url = this.APIServerUrl + '/admin/index'
				let _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				}

				// обнуляем флаг в Vuex о наличии глобального фильтра
				this.$store.commit('accountGlobalFilter', false)

				// делаем сам запрос
				this.$http.get(_url, { 'params': _params }).then(
					// получили успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'ok')
						{
							// стафим флаг в Vuex о наличии глобального фильтра
							this.$store.commit('accountGlobalFilter', true)

							// генерируем событие установки глобального фильтра
							if (window && window.localStorage)
								window.localStorage.setItem('__event', 'agf1' + (new Date()).getTime() + '_' + _accountID)

							// запрос счетчиков
							this.$store.dispatch('getTicketCounters')
							this.$store.dispatch('getRequestCounter')

							// сообщаем что глобальный фильтр установлен
							this.setLocalSuccessMessage('main/set_filter ' + this.account['account_name']['value'])

							// тихо рефрешим ВСЮ страницу
							this.requestVDSData()

							// на этом все
							return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resGet)
					},
					// получили отрицательный ответ сервера
					resGet => {
						this.localErrorMessage = this.formatRequestError(resGet)
					}
				)
			}
			// если это очистка глобального фильтра
			else
			{
				// начинаем очистку фильтра - готовим URL согласно API
				let _url = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter'

				// делаем сам запрос
				this.$http.get(_url).then(
					// получили успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'ok')
						{
							// обнуляем флаг в Vuex о наличии глобального фильтра
							this.$store.commit('accountGlobalFilter', false)

							// генерируем событие снятия глобального фильтра
							if (window && window.localStorage)
								window.localStorage.setItem('__event', 'agf0' + (new Date()).getTime())

							// запрос счетчиков
							this.$store.dispatch('getTicketCounters')
							this.$store.dispatch('getRequestCounter')

							// сообщаем что глобальный фильтр установлен
							this.setLocalSuccessMessage(this.localeFtc('main/filter') + ' ' + this.localeFtc('main/deleted').toLowerCase())

							// тихо рефрешим ВСЮ страницу
							this.requestVDSData()

							// на этом все
							return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resGet)
					},
					// получили отрицательный ответ сервера
					resGet => {
						this.localErrorMessage = this.formatRequestError(resGet)
					}
				)
			}
		},

		//---------------------------------------------------------------------
		// обработчик события "storage"
		//---------------------------------------------------------------------
		onLocalStorageEvent(event) {
			// только для сотрудников
			if (this.$store.state.user_type !== 'admin') return
			// проверка события
			if (!event || event.key !== '__event' || !event.newValue) return

			if (event.newValue.indexOf('agf1') === 0 ||
				event.newValue.indexOf('agf0') === 0)
			{
				// запрос счетчиков
				this.$store.dispatch('getTicketCounters')
				this.$store.dispatch('getRequestCounter')

				// тихо рефрешим ВСЮ страницу
				this.requestVDSData()
			}
		},
		//---------------------------------------------------------------------
		// изменяют URL внутри приложения
		//---------------------------------------------------------------------
		onBeforePopState() {
			// так как на логаут два раза запрос идет - пользователь
			// может быть уже неавторизован
			if (!this.$store.state.is_auth) return true

			// если запущен процесс инициализации начальных значений
			if (this.$store.state.isInitFormsValue > 0) return true

			// если показан диалог блокировки всего приложения
			if (this.$store.state.applicationBlocked)
			{
				return false
			}

			// смотрим - если у нас конструктор и он изменен
			if (this.planData && this.planData.has_params &&
				this.isConstructPlanChanged)
			{
				// спрашиваем
				if (confirm(this.localeFtc('application/leave_page_confirm')))
				{
					return true
				}
				else
				{
					// отмена действия
					return false
				}
			}

			return true
		},
		//---------------------------------------------------------------------
		// закрывают вкладку или делают рефреш
		//---------------------------------------------------------------------
		onBeforeUnload() {
			// смотрим - если у нас конструктор и он изменен
			// при этом, если приложение блокировано - ничего не нужно спрашивать
			if (this.planData && this.planData.has_params &&
				this.isConstructPlanChanged &&
				!this.$store.state.applicationBlocked)
			{
				// сообщение по умолчанию
				return 'Возможно, внесенные изменения не сохранятся.'
			}
		},
		//---------------------------------------------------------------------
		// изменился ли тариф-констуктор
		//---------------------------------------------------------------------
		handlePlanConstructorChanged(value) {
			if (this.planData && this.planData.has_params)
			{
				this.isConstructPlanChanged = value
			}
		},
		//---------------------------------------------------------------------
		// нужно сбросить флаг измененного тарифа конструктора
		// например при смене тарифа
		//---------------------------------------------------------------------
		onDropPlanConstructorChanged() {
			this.isConstructPlanChanged = false
		},
		//---------------------------------------------------------------------
		// компилирует список ISO-образов
		//---------------------------------------------------------------------
		makeIsoList(data) {
			if (!data || !data['fields']) return []

			let _answer = []

			// iso_id
			if (data['fields']['iso_id'] && data['fields']['iso_id']['list'] && data['fields']['iso_id']['list'].length) {
				data['fields']['iso_id']['list'].forEach(val => {
					if (val && val.id && val.name) {
						_answer.push(val)
					}
				})
			}

			// iso_secondary_id
			if (data['fields']['iso_secondary_id'] && data['fields']['iso_secondary_id']['list'] && data['fields']['iso_secondary_id']['list'].length) {
				data['fields']['iso_secondary_id']['list'].forEach(val => {
					if (val && val.id && val.name) {
						let _found = _answer.some(o => {
							if (o && o.id === val.id) return true
						})

						if (!_found) _answer.push(val)
					}
				})
			}

			// sort
			if (_answer.length) {
				_answer.sort((a, b) => a.id - b.id)
			}

			return _answer
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		tabCommand,
		tabAccess,
		tabPlan,
		tabReinstall,
		tabIp,
		tabLocalIp,
		tabBackup,
		tabDisks,
		tabStat,
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-vds-view-wrapper {
	margin: 15px 0 20px 0;
}

.name-in-vds {
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// vdsView.vue?aaec32e8